// extracted by mini-css-extract-plugin
export default {"topbar":"lsf-topbar","topbar__group":"lsf-topbar__group","topbar__section":"lsf-topbar__section","topbar__section_flat":"lsf-topbar__section_flat"};
    if(module.hot) {
      // 1732531516143
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  